var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaePhase5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 417.45 612.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-VAE-P5 {\n        fill: #1a3378;\n        stroke: #1a3378;\n      }\n\n      .cls-2-VAE-P5, .cls-3-VAE-P5 {\n        fill: #edeef0;\n      }\n      .cls-2-VAE-P5:hover,.cls-3-VAE-P5:hover {\n        fill: #edeef0;\n        pointer-events: none;\n      }\n      \n      \n\n      .cls-2-VAE-P5, .cls-4-VAE-P5, .cls-5-VAE-P5, .cls-6-VAE-P5 {\n        stroke: #e87203;\n      }\n\n      .cls-3-VAE-P5, .cls-7-VAE-P5, .cls-8-VAE-P5 {\n        stroke-width: 0px;\n      }\n\n      .cls-4-VAE-P5, .cls-6-VAE-P5 {\n        fill: #e87203;\n      }\n\n      .cls-5-VAE-P5 {\n        fill: none;\n      }\n\n      .cls-7-VAE-P5 {\n        fill: #3a414a;\n      }\n\n      .cls-8-VAE-P5 {\n        fill: #e81313;\n      }\n\n      .cls-6-VAE-P5 {\n        stroke-width: .05px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-VAE-P5",
    d: "m244.85,100.17v52.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-VAE-P5",
    d: "m245.35,100.18h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-VAE-P5",
    d: "m244.85,167.84l-4.63-14.25h9.28l-4.65,14.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-VAE-P5",
    d: "m244.85,269.64v52.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-VAE-P5",
    d: "m245.35,269.64h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-VAE-P5",
    d: "m244.85,337.32l-4.63-14.26h9.28l-4.65,14.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-VAE-P5",
    d: "m72.75,6.5c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H78.75c-3.31,0-6-2.69-6-6V6.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-7-VAE-P5",
    d: "m87.72,24.02v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "cls-7-VAE-P5",
    d: "m101.16,27.49c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "cls-7-VAE-P5",
    d: "m114.34,25.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-7-VAE-P5",
    d: "m137.63,39.23c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-7-VAE-P5",
    d: "m156.5,36.52c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "cls-7-VAE-P5",
    d: "m164.52,35.77c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-2",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m174.09,25.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-7-VAE-P5",
    d: "m190.59,38.96l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-3",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m199.89,25.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-4",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m213.47,25.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "cls-7-VAE-P5",
    d: "m228.07,25.79c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-5",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m240.63,25.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-7-VAE-P5",
    d: "m255.16,27.89c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "cls-7-VAE-P5",
    d: "m276.28,38.96h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-7-VAE-P5",
    d: "m281.51,23.28v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-2",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m289.25,35.77c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-2",
    "data-name": "v",
    className: "cls-7-VAE-P5",
    d: "m299.23,27.49c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-7-VAE-P5",
    d: "m311.39,25.79c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-2",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m326.94,27.89c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-2",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m336.85,36.52c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-2",
    "data-name": "D",
    className: "cls-7-VAE-P5",
    d: "m354.84,38.96h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "cls-7-VAE-P5",
    d: "m367.61,29.25c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z-3",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m381.46,35.77c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-3",
    "data-name": "v",
    className: "cls-7-VAE-P5",
    d: "m391.44,27.49c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-6",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m404.61,25.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "cls-7-VAE-P5",
    d: "m150.43,68.3v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-2",
    "data-name": "u",
    className: "cls-7-VAE-P5",
    d: "m173.31,53.36v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "cls-7-VAE-P5",
    d: "m179.56,68.57l4.89-17.99h1.9l-4.89,17.99h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-2",
    "data-name": "H",
    className: "cls-7-VAE-P5",
    d: "m188.38,68.3v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "cls-7-VAE-P5",
    d: "m206.92,53.36v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "cls-7-VAE-P5",
    d: "m231.16,52.41c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-3",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m238.83,57.23c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-7-VAE-P5",
    d: "m245.96,55.12c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-7-VAE-P5",
    d: "m267.01,56.82c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-7-VAE-P5",
    d: "m294.24,56.14c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-7-VAE-P5",
    d: "m313.25,56.28c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82Zm-11.54,3.26c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "cls-7-VAE-P5",
    d: "m331.32,68.3l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "cls-7-VAE-P5",
    d: "m337.56,68.3v-2.58h2.31v2.58h-2.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-VAE-P5",
    d: "m72.75,175.97c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H78.75c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-7-VAE-P5",
    d: "m106.05,208.43h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-2",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m112.64,192.75v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-4",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m120.38,205.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-4",
    "data-name": "v",
    className: "cls-7-VAE-P5",
    d: "m130.36,196.96c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-2",
    "data-name": "F",
    className: "cls-7-VAE-P5",
    d: "m142.52,195.26c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-4",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m158.07,197.36c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-3",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m167.98,205.99c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-3",
    "data-name": "D",
    className: "cls-7-VAE-P5",
    d: "m185.97,208.43h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "y-4",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m205.94,205.99c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-2",
    "data-name": "G",
    className: "cls-7-VAE-P5",
    d: "m219.11,198.72c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-3",
    "data-name": "G",
    className: "cls-7-VAE-P5",
    d: "m231.33,198.72c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-2",
    "data-name": "L",
    className: "cls-7-VAE-P5",
    d: "m241.18,195.26c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-7-VAE-P5",
    d: "m254.48,196.96c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-3",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m261.82,192.75v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-5",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m275.13,205.99c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-5",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m283.14,205.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-7",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m292.71,195.26c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-3",
    "data-name": "F",
    className: "cls-7-VAE-P5",
    d: "m305.28,195.26c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-7-VAE-P5",
    d: "m330.74,199.54c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87Zm-6.59-.75c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36Zm0,7.81c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-5",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m343.91,197.36c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-4",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m345.88,192.75v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-8",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m356.4,195.26c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-2",
    "data-name": "K",
    className: "cls-7-VAE-P5",
    d: "m370.05,192.54c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-5",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m371.61,192.75v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "cls-7-VAE-P5",
    d: "m383.29,195.26c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "cls-7-VAE-P5",
    d: "m400.95,195.53c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04Zm-5.64,11.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    className: "cls-7-VAE-P5",
    d: "m222.4,238.04c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "cls-7-VAE-P5",
    d: "m237.41,238.04c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-6",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m246.91,222.08v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-4",
    "data-name": "F",
    className: "cls-7-VAE-P5",
    d: "m256.42,224.59c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-9",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m271.02,224.59c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-VAE-P5",
    d: "m72.75,345.44c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H78.75c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "cls-7-VAE-P5",
    d: "m106.66,381.76c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-10",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m117.19,381.42c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-2",
    "data-name": "U",
    className: "cls-7-VAE-P5",
    d: "m131.92,381.42c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-5",
    "data-name": "F",
    className: "cls-7-VAE-P5",
    d: "m143.33,381.42c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "D-4",
    "data-name": "D",
    className: "cls-7-VAE-P5",
    d: "m171.92,394.59h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-7",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m177.15,378.9v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-6",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m184.89,391.4c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-5",
    "data-name": "v",
    className: "cls-7-VAE-P5",
    d: "m194.87,383.11c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-6",
    "data-name": "F",
    className: "cls-7-VAE-P5",
    d: "m207.02,381.42c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-6",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m222.57,383.52c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-6",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m232.48,392.15c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-5",
    "data-name": "D",
    className: "cls-7-VAE-P5",
    d: "m250.48,394.59h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-7",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m263.65,392.15c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-7-VAE-P5",
    d: "m269.29,394.59v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U-3",
    "data-name": "U",
    className: "cls-7-VAE-P5",
    d: "m287.76,381.42c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-3",
    "data-name": "L",
    className: "cls-7-VAE-P5",
    d: "m300.18,381.42c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-7",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m310.98,391.4c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-8",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m315.39,378.9v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-3",
    "data-name": "K",
    className: "cls-7-VAE-P5",
    d: "m325.98,378.7c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-9",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m327.55,378.9v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-2",
    "data-name": "S",
    className: "cls-7-VAE-P5",
    d: "m337.8,383.11c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-8",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m353.08,392.15c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-8",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m361.09,391.4c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-10",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m365.5,378.9v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-4",
    "data-name": "L",
    className: "cls-7-VAE-P5",
    d: "m376.03,381.42c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-4",
    "data-name": "U",
    className: "cls-7-VAE-P5",
    d: "m390.76,381.42c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-VAE-P5",
    d: "m72.75,519.51c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H78.75c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "cls-7-VAE-P5",
    d: "m95.9,551.98h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-11",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m108.33,538.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-12",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m121.91,538.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-7-VAE-P5",
    d: "m136.03,551.98h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-9",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m150.49,549.53c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "N-2",
    "data-name": "N",
    className: "cls-7-VAE-P5",
    d: "m175.69,539.82c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-5",
    "data-name": "L",
    className: "cls-7-VAE-P5",
    d: "m185.67,538.8c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-6",
    "data-name": "L",
    className: "cls-7-VAE-P5",
    d: "m199.25,538.8c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-7",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m213.78,540.91c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-7",
    "data-name": "F",
    className: "cls-7-VAE-P5",
    d: "m219.89,538.8c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-11",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m229.33,536.29v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-5",
    "data-name": "U",
    className: "cls-7-VAE-P5",
    d: "m241.01,538.8c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-10",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m256.22,549.53c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-9",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m264.23,548.78c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-7",
    "data-name": "L",
    className: "cls-7-VAE-P5",
    d: "m273.8,538.8c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-8",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m288.33,540.91c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "C-9",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m303.2,540.91c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-13",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m310.33,538.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-10",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m321.13,548.78c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-12",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m325.54,536.29v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-10",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m337.02,540.91c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-14",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m344.15,538.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-4",
    "data-name": "G",
    className: "cls-7-VAE-P5",
    d: "m360.11,542.27c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d-2",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z-11",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m373.96,548.78c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-6",
    "data-name": "v",
    className: "cls-7-VAE-P5",
    d: "m383.94,540.5c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-15",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m397.11,538.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M-2",
    "data-name": "M",
    className: "cls-7-VAE-P5",
    d: "m165.33,569.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-11",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m180.95,578.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-12",
    "data-name": "z",
    className: "cls-7-VAE-P5",
    d: "m188.96,578.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-16",
    "data-name": "w",
    className: "cls-7-VAE-P5",
    d: "m198.53,568.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-11",
    "data-name": "C",
    className: "cls-7-VAE-P5",
    d: "m213.07,570.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-13",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m215.03,565.62v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-12",
    "data-name": "y",
    className: "cls-7-VAE-P5",
    d: "m228.34,578.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-2",
    "data-name": "Y",
    className: "cls-7-VAE-P5",
    d: "m233.98,581.31v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "E-14",
    "data-name": "E",
    className: "cls-7-VAE-P5",
    d: "m246.13,565.62v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-6",
    "data-name": "U",
    className: "cls-7-VAE-P5",
    d: "m257.81,568.14c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z-2",
    "data-name": "Z",
    className: "cls-7-VAE-P5",
    d: "m279.54,581.31h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-3",
    "data-name": "Z",
    className: "cls-7-VAE-P5",
    d: "m295.84,581.31h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-7-VAE-P5",
    d: "m304.87,564.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84Zm2.24,8.49c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-2",
    "data-name": "P",
    className: "cls-7-VAE-P5",
    d: "m335.42,581.31l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-VAE-P5",
    d: "m244.85,439.11v57.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-VAE-P5",
    d: "m245.35,439.12h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-VAE-P5",
    d: "m244.85,511.39l-4.64-14.25h9.28l-4.64,14.25Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-VAE-P5",
    x: 0.01,
    y: 196.61,
    width: 2.74,
    height: 38.03,
    style: {
      fill: "#ebf5fe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-VAE-P5",
    x: 1.14,
    y: 195.89,
    width: 68.93,
    height: 2.94,
    style: {
      fill: "#ebf5fe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-VAE-P5",
    x: 66.79,
    y: 196.61,
    width: 2.77,
    height: 38.11,
    style: {
      fill: "#ebf5fe"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaePhase5);
export default __webpack_public_path__ + "static/media/VAE_Phase_5.c83bfd8cea0193869a1d532ccdbe2b9e.svg";
export { ForwardRef as ReactComponent };